export const selectUSDRateBuy = state => state.currency.USD.rateBuy;
export const selectUSDRateSell = state => state.currency.USD.rateSell;
export const selectEURRateBuy = state => state.currency.EUR.rateBuy;
export const selectEURRateSell = state => state.currency.EUR.rateSell;
export const selectCurrencyDate = state => state.currency.currencyDate;
